import { HandleClientError } from './client-error-service';
import { LocalStorageService } from './local-storage-service';

export interface UserPreferences {
	saveGridSettings: boolean;
	showInputHelp: boolean;
	emailNotifications: boolean;
}

const userPreferencesKey = 'UserPreferences';

class UserPreferencesService implements LocalStorageService {
	private static _instance: UserPreferencesService;
	preferences: Promise<UserPreferences>;

	public static get Instance() {
		return this._instance || (this._instance = new this());
	}

	public async Initialize(): Promise<void> {
		var localPreferences = localStorage.getItem(userPreferencesKey);
		if (!!localPreferences && localPreferences !== '{}') {
			this.preferences = new Promise<UserPreferences>((res) => { res(JSON.parse(localPreferences)) });
		} else {
			await this.RefreshData();
		}
	}

	public async RefreshData(): Promise<void> {
		this.preferences = fetch(`/ClientPreferences/GetCurrentUserPreferences`)
			.then((res) => res.json())
			.catch((e) => HandleClientError('UserPreferencesService.Initialize()', e));
		this.preferences.then(preferences => {
			localStorage.setItem(userPreferencesKey, JSON.stringify(preferences));
		});
	}

	public async UpdateUserPreferences(newPreferences: UserPreferences): Promise<boolean> {
		return (await fetch(`/ClientPreferences/UpdateUserPreferences`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-ANTIFORGERY-TOKEN': (document.querySelector('[Name="AntiForgeryToken"]') as HTMLInputElement).value,
			},
		  body: JSON.stringify(newPreferences)
		})
		.then(async (res) => {
			var result = res.json();
			localStorage.setItem(userPreferencesKey, JSON.stringify(newPreferences));
			return result;
		})
		.catch((e) => HandleClientError('UpdateUserPreferences', e)));
	}
}

const userPreferencesService = UserPreferencesService.Instance;

export default userPreferencesService;
